import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import '../_studenthome.scss'
import '../_homefresh.scss'
import '../_homeheader.scss'

// Loading placeholders for the NEET/JEE home, shaped like the real page so
// nothing jumps when the data arrives. Shimmer blocks come from .rz-shimmer
// in _studentmodule.scss.

const Bar = ({ w, h = 12, className = "", style }) => (
    <span className={`rz-shimmer ${className}`} style={{ width: w, height: h, ...style }} />
);

// Stands in for HomeNavbar's header (bar + greeting) while the home loads.
export const HomeHeaderSkeleton = () => (
    <div className="common-header student-top-nav home-top-nav home-skel-header">
        <Container className="home-container">
            <div className="home-skel-bar">
                <Bar w={42} h={42} style={{ borderRadius: 12 }} />
                <Bar w={110} h={22} />
                <span className="home-skel-bar-right">
                    <Bar w={34} h={34} className="rz-skel-circle" />
                    <Bar w={34} h={34} className="rz-skel-circle" />
                    <Bar w={96} h={36} style={{ borderRadius: 999 }} />
                    <Bar w={160} h={46} style={{ borderRadius: 16 }} />
                </span>
            </div>
            <div className="home-skel-greeting">
                <Bar w={90} h={14} />
                <Bar w={260} h={26} />
                <Bar w={300} h={12} />
            </div>
        </Container>
    </div>
);

const SubjectSkeleton = () => (
    <div className="home-skel-subject">
        <div className="d-flex align-items-center mb-3">
            <Bar w={46} h={46} style={{ borderRadius: 12 }} />
            <Bar w="45%" h={18} style={{ marginLeft: 12 }} />
        </div>
        <Bar w="80%" h={11} style={{ marginBottom: 12 }} />
        <Bar w="100%" h={10} style={{ borderRadius: 999 }} />
    </div>
);

// Placeholder for the preparation life cycle panel.
export const LifecycleSkeleton = () => (
    <div className="rz-skel-card home-skel-panel home-skel-lifecycle">
        <Bar w="45%" h={18} style={{ margin: '0 auto 10px' }} />
        <Bar w="30%" h={12} style={{ margin: '0 auto 28px' }} />
        <div className="home-skel-steps">
            {[1, 2, 3, 4].map((n) => (
                <div key={n} className="home-skel-step">
                    <Bar w={84} h={84} className="rz-skel-circle" style={{ margin: '0 auto 16px' }} />
                    <Bar w="80%" h={30} style={{ margin: '0 auto 8px', borderRadius: 10 }} />
                    <Bar w="70%" h={30} style={{ margin: '0 auto', borderRadius: 10 }} />
                </div>
            ))}
        </div>
    </div>
);

// Placeholders for the two exam cards (rendered inside a Row).
export const ExamCardsSkeleton = () => (
    <React.Fragment>
        {[1, 2].map((n) => (
            <Col key={n} md={6} sm={12} className="my-3">
                <div className="rz-skel-card home-skel-exam d-flex align-items-center">
                    <Bar w={52} h={52} style={{ borderRadius: 12 }} />
                    <span style={{ marginLeft: 16, flex: 1 }}>
                        <Bar w="45%" h={16} style={{ marginBottom: 10 }} />
                        <Bar w="30%" h={12} />
                    </span>
                    <Bar w={130} h={42} style={{ borderRadius: 999 }} />
                </div>
            </Col>
        ))}
    </React.Fragment>
);

const HomeSkeleton = () => (
    <section className="student-home home-fresh home-skel" aria-busy="true" aria-label="Loading your home page">
        <div className="student-subject-card">
            {[1, 2, 3, 4].map((n) => <SubjectSkeleton key={n} />)}
        </div>
        <Row className="home-main-row">
            <Col xs={12} className="my-3 home-col-practice">
                <div className="rz-skel-card home-skel-panel">
                    <div className="d-flex align-items-center mb-4">
                        <Bar w={44} h={44} style={{ borderRadius: 10 }} />
                        <span style={{ marginLeft: 12, flex: 1 }}>
                            <Bar w="55%" h={16} style={{ marginBottom: 8 }} />
                            <Bar w="40%" h={11} />
                        </span>
                    </div>
                    {[1, 2, 3, 4, 5].map((n) => (
                        <div key={n} className="d-flex align-items-center home-skel-row">
                            <Bar w={36} h={36} className="rz-skel-circle" />
                            <Bar w="50%" h={12} style={{ marginLeft: 12, flex: 1 }} />
                            <Bar w={84} h={26} style={{ borderRadius: 999, marginLeft: 12 }} />
                        </div>
                    ))}
                </div>
            </Col>
            <Col xs={12} className="my-3 home-col-lifecycle">
                <LifecycleSkeleton />
            </Col>
            <ExamCardsSkeleton />
        </Row>
    </section>
);

export default HomeSkeleton;
